import React, { useState } from "react";
import "./PersonCard.css";
import SelectDropDownComp from "../selectDropDownComp";
import iq_api_v2 from "../../../../../services/iqApiV2";
import { useUser } from "../../../../../context/UserContext";
import { useDispatch } from "react-redux";
import { FetchSpotContactsRequest } from "../../../../../store/features/actions/targetedReachout/spotContactsActions";
import { useParams } from "react-router-dom";


const handleTagAndSaveContact = async (userId, linkedInUrl, selectedOpportunities, setContactSaved,clientName, accountName,dispatch) => {

  try {
    const payload = {
      user_id: userId,
      linkedin_url: linkedInUrl,
      opportunity_ids: [selectedOpportunities._id],
    };

    const res = await iq_api_v2.post("contact/add_contact_against_opportunity", payload);

    if (res?.status === 200) {
      setContactSaved(true);
            if (res?.data) {
            dispatch(
              FetchSpotContactsRequest({
                clientName,
                accountName,
                userId:userId,
                type: "spot",
              })
            );
            }
    } else {
      throw new Error("API response status not 200");
    }
  } catch (error) {
    console.error("❌ Error in handleTagAndSaveContact:", error);
    setContactSaved(false); // optionally reset or notify failure
  }
};


const AddContactForm = ({ dropDownData,url, onApplyDropdown =()=>null}) => {
    const dispatch = useDispatch();
  const {user} = useUser();
  const [selectedOpportunities, setSelectedOpportunities] = useState([]);
  const { clientName, accountName } = useParams();
  const [contactSaved,setContactSaved]= useState(false);
  return (
    <div className="chatbot-add-container">
      <div className="chatbot-form-header">
        <span className="chatbot-form-text-titl">Please choose opportunity to tag against a your contact</span>
        {/* <span className="chatbot-form-text-titl clickable" onClick={() => setSelectedOpportunities([])}>
          Clear
        </span> */}
      </div>
      <SelectDropDownComp
        allOptions={dropDownData}
        selectedValues={selectedOpportunities}
        setSelectedValues={setSelectedOpportunities}
        onApply={(selected)=>{
            handleTagAndSaveContact(user?.id , url ,selected,setContactSaved,clientName, accountName ,dispatch)}}
        multiSelect={false}
        valueKey="_id"
        labelKey="opportunity_name"
        disableFooter={!selectedOpportunities}
        submitTxt={contactSaved ? "Saved":"Tag & Save"} 
        disabledSubmit={contactSaved || selectedOpportunities?.length ==0}
      />
    </div>
  );
};

const PersonCard = ({ person, onSelectChange , dropDownData}) => {
  const [showOppDropDown, setShowOppDropDown] = useState(false);
  const [imageError, setImageError] = useState(false);




  const getInitials = (name) => {
    if (!name) return "";
    const [first, last] = name.split(" ");
    return `${first?.[0] || ""}${last?.[0] || ""}`.toUpperCase();
  };

  return (
    <div className={`person-card-container `}>
      <div className="person-card-header">
        {imageError || !person.photo_url ? (
          <div className="person-card-initials-fallback">{getInitials(person.name)}</div>
        ) : (
          <img
            src={person.photo_url}
            alt={person.name}
            className="person-card-profile-pic"
            onError={() => setImageError(true)}
          />
        )}

      </div>

      <div className="person-card-info">
        <h3 className="person-card-name">{person.name}</h3>
        <p className="person-card-title">{person.title}</p>
        <p className="person-card-org">{person.organization?.name}</p>
        <p className="person-card-location">{person.city}, {person.country}</p>

        {showOppDropDown && (
          <div className="person-card-more">
            <p>Email Status: <strong>{person.email_status}</strong></p>
            {person.linkedin_url && (
              <p>
                LinkedIn: <a href={person.linkedin_url} target="_blank" rel="noreferrer">View Profile</a>
              </p>
            )}
            {person.employment_history?.length > 0 && (
              <ul className="person-card-job-history">
                {person.employment_history.slice(0, 3).map((job) => (
                  <li key={job.id}>{job.title} @ {job.organization_name}</li>
                ))}
              </ul>
            )}
          </div>
        )}

        {
          showOppDropDown && 
          <div className="mt-2">  <AddContactForm dropDownData={dropDownData} url={person.linkedin_url}/></div>
        
        }





        <div className="person-card-button-row">
          <button className="person-card-toggle-btn" onClick={() => setShowOppDropDown(prev => !prev)}>
            {showOppDropDown ? "Hide" : "Tag & Save Contact"}
          </button>
        </div>
      </div>
    </div>
  );
};

export default PersonCard;
